import React from 'react'
import {useNavigate} from 'react-router-dom'
import {ModeleGenre, modeleGenreInitValues} from '../../../components/Models'
import {GenreForm} from './components/GenreForm'
import {createGenre} from '../../../components/requests'

const GenreAddPage = () => {
  const navigate = useNavigate();
  const submitForm = async (fieldsToUpdate: Partial<ModeleGenre>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleGenreInitValues}, fieldsToUpdate)

    var requestOk = false;
    try {
      const clientRequest = await createGenre(updatedData);
      if (clientRequest?.status === 200) {
        if (clientRequest?.data?.id !== undefined && clientRequest?.data?.id !== null) {
          requestOk = true;
          navigate(`/genres`);
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback();
    }

  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Créer un genre</h3>
          </div>
        </div>

        <div>
          <GenreForm genreId={null} data={modeleGenreInitValues} submitForm={submitForm} />
        </div>
      </div>
    </>
  )
}

export {GenreAddPage}
